import { getOrderDescriptionsById } from '../helper'

export const OrderDescriptionCell = ({
  data,
  rowId,
  orderInfoKey,
  orderNameKey,
}) => {
  const orderTypesItem =
    getOrderDescriptionsById(data, rowId, orderInfoKey, orderNameKey) || []
  const firstOrderItem = orderTypesItem[0]
  const remainingOrderItems = orderTypesItem.slice(1)

  return (
    <>
      {firstOrderItem ?? ''}
      {!!remainingOrderItems.length &&
        remainingOrderItems.map((item, index) => (
          <div className="mt1" key={index}>
            {item}
          </div>
        ))}
    </>
  )
}
